export default {
  translation: {
    actions: {
      goBack: 'Go back',
      search: 'Search country',
      logout: 'Logout',
    },
    dates: {
      year: 'Year',
      month: 'Month',
      day: 'Day',
      display: {
        withYear: 'LLL dd, yyyy',
        withoutYear: 'LLL dd',
      },
    },
    apiErrors: {
      unauthorized: {
        message: 'Session expired',
        description: 'Your session is not valid, you have to sign in again',
      },
      forbidden: {
        message: 'Forbidden',
        description: 'You are not authorized to do this',
      },
      notFound: {
        message: 'Not Found',
        description: 'The resource you requested could not be found',
      },
      serverError: {
        message: 'Error',
        description: 'There was an error processing your request, please try again later',
      },
      answerFriendshipRequest: {
        message: 'Oops!',
        description: 'There was a problem answering this friendship request',
      },
      phoneValidation: {
        message: 'Oops!',
        description: 'There was a problem validating your phone number',
      },
      invalidShareableToken: {
        message: 'Oops!',
        description: 'It seems the link you used is no longer valid.',
      },
    },
    answerRequest: {
      cancelText: 'cancel',
      reason: 'This will help your friends make sure they are reminded of your birthday.',
      withYear: 'With Year',
      withoutYear: 'No Year',
      submit: 'Share with {{inviterName}}',
      confirmText: 'Ok',
      failed: 'Oops! There was an error when answering your birthday!',
      withSession: {
        submit: 'Share',
        title: 'Hey {{currentUserName}}, help {{inviterName}} celebrate your birthday.',
        shareInformation: 'You are going to share with {{inviterName}} the following information:',
        clearSession: 'Not {{currentUserName}}? Clear session',
      },
      shareableLinks: {
        title: 'Help {{inviterName}} celebrate your birthday.',
      },
      directLinks: {
        title: '{{invitedName}}, help {{inviterName}} celebrate your birthday.',
      },
      rememberMe: 'Remember me',
    },
    phoneValidation: {
      explanation: {
        mandatory: 'We found this phone number already on Cupcake but with different personal info. We are sending you a verification code via SMS to keep the account secure.',
        voluntaryBeginning: "Thanks for sharing your birthday with {{inviterName}}. You're done.",
        voluntaryEnding: "If you want to register and remember {{inviterName}}'s birthday, verify your phone number below.",
      },
      smsButton: 'Send verification code via SMS',
      skipButton: 'Skip',
      form: {
        instructions: 'Enter the {{length}} digit code we sent to you via SMS',
        submit: 'Verify code',
        resendSMS: 'Resend SMS to {{phoneNumber}}',
        error: {
          message: 'Oops!',
          description: 'There was a problem validating your SMS code. Make sure you entered the code correctly',
        },
      },
    },
    downloadLinks: {
      thankYou: 'Thank you!',
      downloadTheApp: "Keep track of your friends' birthdays.",
    },
    termsOfService: {
      title: 'Terms of Service',
    },
    privacyPolicy: {
      title: 'Cupcake Privacy Policy',
    },
    user: {
      countryCode: 'Country dial code',
      firstName: 'First name',
      lastName: 'Last name',
      phoneNumber: 'Phone number',
      name: 'Name',
      birthday: 'Birthday',
    },
    validations: {
      required: 'Required',
      invalidPhoneNumber: 'Invalid phone number',
      digitCodeLength: 'Must be a {{length}} digit code',
    },
    feedback: {
      logout: {
        message: 'Signed out successfully',
      },
    },
  },
};
